module.exports = __webpack_public_path__ + "static/media/icon-close.cf1a8750.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CloseIcon/icon-close.svg
// module id = 564
// module chunks = 1